import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import { defaultProjectHash } from '../../../../../../config';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function UpdateModule({

  lineData,

}: ICreateModule): JSX.Element {
  const { handleApiErrors } = useAuth();
  const { addToast } = useToast();


  const handleSend = async (id: string): Promise<void> => {
    try {

      const findsale = await api.get(`/sales`, {
        params: {
          where: {
            project_id: defaultProjectHash,
            client_id: id
          }
        }
      });

      if (findsale?.data?.rows?.length < 1) {
        const sale = await api.post(`/sales`, { project_id: defaultProjectHash, event_id: defaultProjectHash, client_id: id, product_id: '649da0d5a5e76fe1a64caa4f', payment_status_id: 'paid', payment_method_id: 'cortesy', quantity: 1 });

        const response = await api.post(`/send-sale-mail/${sale?.data?.sale_hash?.toString()}`);
      }
      else {
        const response = await api.post(`/send-sale-mail/${findsale?.data?.rows?.[0]?.sale_hash?.toString()}`);
      }

      addToast({ title: 'Confirmado com sucesso!', type: 'success' });
    }
    catch (err) {
      handleApiErrors(err);
    }
  };

  const moduleUpdate = (id: string): JSX.Element => (
    id ? <button className="lineIcon" title="Editar" type="button" onClick={() => handleSend(id)}>
      <FiSend />
    </button> : <></>
  );

  return moduleUpdate(lineData._id?.toString());
}
